import { Action } from 'redux';
import {
    EmailMarketingKpis,
    EmailMarketingLocation,
    EmailMarketingSender,
    EmailMarketingTemplateOption,
    OrganizationCampaign
} from 'model/emailMarketing';

// Error actions
export const EMAIL_MARKETING_ERROR = 'emailMarketing/error';
export interface EmailMarketingErrorAction extends Action<typeof EMAIL_MARKETING_ERROR> {
    payload: { error: string };
}

export const EMAIL_MARKETING_CLEAR_ERROR = 'emailMarketing/clear_error';
export type EmailMarketingClearErrorAction = Action<typeof EMAIL_MARKETING_CLEAR_ERROR>;

// Locations (picker)
export const EMAIL_MARKETING_LOCATIONS_FETCH_START = 'emailMarketing/locations/fetch_start';
export type EmailMarketingLocationsFetchStartAction = Action<typeof EMAIL_MARKETING_LOCATIONS_FETCH_START>;

export const EMAIL_MARKETING_LOCATIONS_FETCH_SUCCESS = 'emailMarketing/locations/fetch_success';
export interface EmailMarketingLocationsFetchSuccessAction
    extends Action<typeof EMAIL_MARKETING_LOCATIONS_FETCH_SUCCESS> {
    payload: { locations: Array<EmailMarketingLocation> };
}

// Templates (picker)
export const EMAIL_MARKETING_TEMPLATES_FETCH_START = 'emailMarketing/templates/fetch_start';
export type EmailMarketingTemplatesFetchStartAction = Action<typeof EMAIL_MARKETING_TEMPLATES_FETCH_START>;

export const EMAIL_MARKETING_TEMPLATES_FETCH_SUCCESS = 'emailMarketing/templates/fetch_success';
export interface EmailMarketingTemplatesFetchSuccessAction
    extends Action<typeof EMAIL_MARKETING_TEMPLATES_FETCH_SUCCESS> {
    payload: { templates: Array<EmailMarketingTemplateOption> };
}

// Campaign list
export const EMAIL_MARKETING_CAMPAIGNS_FETCH_START = 'emailMarketing/campaigns/fetch_start';
export type EmailMarketingCampaignsFetchStartAction = Action<typeof EMAIL_MARKETING_CAMPAIGNS_FETCH_START>;

export const EMAIL_MARKETING_CAMPAIGNS_FETCH_SUCCESS = 'emailMarketing/campaigns/fetch_success';
export interface EmailMarketingCampaignsFetchSuccessAction
    extends Action<typeof EMAIL_MARKETING_CAMPAIGNS_FETCH_SUCCESS> {
    payload: { campaigns: Array<OrganizationCampaign> };
}

// Campaign detail
export const EMAIL_MARKETING_CAMPAIGN_FETCH_START = 'emailMarketing/campaign/fetch_start';
export type EmailMarketingCampaignFetchStartAction = Action<typeof EMAIL_MARKETING_CAMPAIGN_FETCH_START>;

export const EMAIL_MARKETING_CAMPAIGN_FETCH_SUCCESS = 'emailMarketing/campaign/fetch_success';
export interface EmailMarketingCampaignFetchSuccessAction
    extends Action<typeof EMAIL_MARKETING_CAMPAIGN_FETCH_SUCCESS> {
    payload: { campaign: OrganizationCampaign };
}

// Create, update, duplicate and send all return the saved campaign.
export const EMAIL_MARKETING_CAMPAIGN_SAVE_START = 'emailMarketing/campaign/save_start';
export type EmailMarketingCampaignSaveStartAction = Action<typeof EMAIL_MARKETING_CAMPAIGN_SAVE_START>;

export const EMAIL_MARKETING_CAMPAIGN_SAVE_SUCCESS = 'emailMarketing/campaign/save_success';
export interface EmailMarketingCampaignSaveSuccessAction extends Action<typeof EMAIL_MARKETING_CAMPAIGN_SAVE_SUCCESS> {
    payload: { campaign: OrganizationCampaign };
}

export const EMAIL_MARKETING_CAMPAIGN_DELETE_SUCCESS = 'emailMarketing/campaign/delete_success';
export interface EmailMarketingCampaignDeleteSuccessAction
    extends Action<typeof EMAIL_MARKETING_CAMPAIGN_DELETE_SUCCESS> {
    payload: { campaignId: number };
}

// KPIs
export const EMAIL_MARKETING_KPIS_FETCH_START = 'emailMarketing/kpis/fetch_start';
export type EmailMarketingKpisFetchStartAction = Action<typeof EMAIL_MARKETING_KPIS_FETCH_START>;

export const EMAIL_MARKETING_KPIS_FETCH_SUCCESS = 'emailMarketing/kpis/fetch_success';
export interface EmailMarketingKpisFetchSuccessAction extends Action<typeof EMAIL_MARKETING_KPIS_FETCH_SUCCESS> {
    payload: { kpis: EmailMarketingKpis };
}

// Senders
export const EMAIL_MARKETING_SENDERS_FETCH_START = 'emailMarketing/senders/fetch_start';
export type EmailMarketingSendersFetchStartAction = Action<typeof EMAIL_MARKETING_SENDERS_FETCH_START>;

export const EMAIL_MARKETING_SENDERS_FETCH_SUCCESS = 'emailMarketing/senders/fetch_success';
export interface EmailMarketingSendersFetchSuccessAction extends Action<typeof EMAIL_MARKETING_SENDERS_FETCH_SUCCESS> {
    payload: { senders: Array<EmailMarketingSender> };
}

// Save, disable or refresh one location's sender.
export const EMAIL_MARKETING_SENDER_SAVE_SUCCESS = 'emailMarketing/sender/save_success';
export interface EmailMarketingSenderSaveSuccessAction extends Action<typeof EMAIL_MARKETING_SENDER_SAVE_SUCCESS> {
    payload: { sender: EmailMarketingSender };
}

export type EmailMarketingAction =
    | EmailMarketingErrorAction
    | EmailMarketingClearErrorAction
    | EmailMarketingLocationsFetchStartAction
    | EmailMarketingLocationsFetchSuccessAction
    | EmailMarketingTemplatesFetchStartAction
    | EmailMarketingTemplatesFetchSuccessAction
    | EmailMarketingCampaignsFetchStartAction
    | EmailMarketingCampaignsFetchSuccessAction
    | EmailMarketingCampaignFetchStartAction
    | EmailMarketingCampaignFetchSuccessAction
    | EmailMarketingCampaignSaveStartAction
    | EmailMarketingCampaignSaveSuccessAction
    | EmailMarketingCampaignDeleteSuccessAction
    | EmailMarketingKpisFetchStartAction
    | EmailMarketingKpisFetchSuccessAction
    | EmailMarketingSendersFetchStartAction
    | EmailMarketingSendersFetchSuccessAction
    | EmailMarketingSenderSaveSuccessAction;
